import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { CreateIntakeFormRequest } from '@/definitions/intakeForm'
import { CreateIntakeForm } from '@/services/IntakeFormService'
import { isTimeoutError } from '@/utils/apiErrors'

interface CreateIntakeFormVariables {
  orgId: string
  data: CreateIntakeFormRequest
}

export const useCreateIntakeForm = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ orgId, data }: CreateIntakeFormVariables) =>
      CreateIntakeForm(orgId, data),
    // A refusal names part of the submitted definition, so the caller shows it
    // beside that rather than as a toast.
    meta: { suppressGlobalError: true },
    onSuccess: (_form, { orgId }) => {
      queryClient.invalidateQueries({ queryKey: ['intakeForms', orgId] })
    },
    // Unlike a refusal, a timeout may have committed — so what is cached is a guess.
    onError: (error, { orgId }) => {
      if (isTimeoutError(error)) {
        queryClient.invalidateQueries({ queryKey: ['intakeForms', orgId] })
      }
    },
  })
}
